import { render, staticRenderFns } from "./yeni.vue?vue&type=template&id=313f50b4&scoped=true&"
import script from "./yeni.vue?vue&type=script&lang=js&"
export * from "./yeni.vue?vue&type=script&lang=js&"
import style0 from "./yeni.vue?vue&type=style&index=0&id=313f50b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f50b4",
  null
  
)

export default component.exports